import Vue from 'vue'
import BootstrapVue from "bootstrap-vue"
import VueClipboard from 'vue-clipboard2'
import VueSimpleMarkdown from 'vue-simple-markdown'
import 'babel-polyfill'
import SocialSharing from 'vue-social-sharing'


import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap-vue/dist/bootstrap-vue.css"
import 'vue-simple-markdown/dist/vue-simple-markdown.css'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faArrowCircleRight, faTimes, faGenderless, faUndo } from '@fortawesome/free-solid-svg-icons'
import { fab, faFacebook, faTwitter, faLine } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import App from './App.vue'

library.add(faArrowCircleRight, faTimes, faGenderless, faUndo, fab, faFacebook, faTwitter, faLine)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(SocialSharing)
Vue.use(BootstrapVue)
Vue.use(VueClipboard)
Vue.use(VueSimpleMarkdown)

new Vue({
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js